import(/* webpackMode: "eager" */ "/home/runner/work/DLOM/DLOM/frontend/app/documentation/page.tsx");
